// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  staging: false,
  bifrostUrl: 'https://api.next.smartgreen.net/graphql/',
  geoServerUrl: 'https://geoserver.next.smartgreen.net/',
  geoRedisConnectorUrl: 'https://redis-connector.next.smartgreen.net/',
  gatewayWebSocketUrl: 'wss://gateway-manager.next.smartgreen.net/',
  googleMapsApiKeyUrl: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDkByB-anoaV7XKBjmiuxZKPh2zdQiOGuE&libraries=places"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
